module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAfElEQVR4AWOgCzgnqEYkopuG/2jgyb7bfVnXp2YDGWgy2DTc37zSx/ZcpuflPL+V3jb/764jpOFk7Vwri3o97Xpt9blWlv8P5RDQ0L/iclBAf4RjYbhTcUhAX92sMwQ0/Pv3f/aG61YpG4zi1k5dc/Xv33/IsoMxHgYlAACIqgQFABmUfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PF.png
// module id = 1238
// module chunks = 0